import { IconCell as CssModulesIconCell, IconCellProps as CssModulesIconCellProps } from '@sunwebgroup/uds-ui/icon-cell'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/icon-cell' instead.
 */
export default Object.assign(
  styled(CssModulesIconCell)<CssModulesIconCellProps>``,
  { displayName: 'IconCell' },
)
